import moment from "moment";

const bulans = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Mei',
    'Jun',
    'Jul',
    'Agu',
    'Sep',
    'Okt',
    'Nov',
    'Des',
]

const haris = [
    'Minggu',
    'Senin',
    'Selasa',
    'Rabu',
    'Kamis',
    'Jumat',
    'Sabtu',
]

export function dateFormatIndo(s) {
    if (s.length < 10) return "Invalid Date"

    const tahun = s.substr(0, 4)
    const bulan = s.substr(5, 2)
    const tanggal = s.substr(8, 2)

    return `${tanggal} ${bulans[parseInt(bulan) - 1]} ${tahun}`
}

export function dateFormatIndoWithDay(s) {
    if (s.length < 10) return "Invalid Date"

    const tahun = s.substr(0, 4)
    const bulan = s.substr(5, 2)
    const tanggal = s.substr(8, 2)

    const date = new Date(s)
    const hari = haris[date.getDay()]

    return `${hari}, ${tanggal} ${bulans[parseInt(bulan) - 1]} ${tahun}`
}

export function dateFormatIndoShort(s) {
    if (s.length < 10) return "Invalid Date"

    const tahun = s.substr(2, 2)
    const bulan = s.substr(5, 2)
    const tanggal = s.substr(8, 2)

    return `${tanggal}/${bulan}/${tahun}`
}

export function dateFormatIndoWithTime(s) {
    if (s.length < 16) return "Invalid Date"

    const tgl = dateFormatIndo(s)
    const jam = s.substr(11, 5)

    return `${tgl} ${jam}`
}

export function dateFormatIndoShortWithTime(s) {
    if (s.length < 16) return "Invalid Date"

    const tgl = dateFormatIndoShort(s)
    const jam = s.substr(11, 5)

    return `${tgl} ${jam}`
}

export function dateOnlyHourMinute(s) {
    if (s.length < 5) return "Invalid Date"
    return s.substr(0, 5)
}

export function formatPrice(i) {
    return String(i).replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

export function isDateWithin(date, range) {
    if (range === "this_day") {
        return moment(date).isSame(moment(), 'day')
    }
    else if (range === "this_week") {
        const d = moment().format("d")

        let startOffset = 1 - d
        if (startOffset > 0) startOffset -= 7

        const endOffset = (7 - d) % 7

        const dateStart = moment().subtract(-startOffset, 'days')
        const dateEnd = moment().add(endOffset, 'days')

        return moment(date).isBetween(dateStart, dateEnd, null, '[]')
    }
    else if (range === "this_month") {
        return moment(date).isSame(moment(), 'month')
    }
    else {
        const ranges = range.split(" ")
        console.log(ranges)
        console.log(ranges.length)

        if (ranges.length === 1) {
            return moment(date).isSame(moment(ranges[0]), 'day')
        }
        else if (ranges.length === 2) {
            return moment(date).isBetween(ranges[0], ranges[1], null, '[]')
        }
        else {
            return true
        }
    }
}